import Environment from './environment.js';

export default class Staging extends Environment {
  constructor(config){
    super(config)
    this._name = 'staging';
  }
}
